(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cashback-calculator"] && !Shopify.designMode) return;
  try {
    
  const range = document.querySelector('.spend_range');
  const value = document.querySelector('.spend');
  const cashback = document.querySelector('.cashback');

  range.addEventListener('input', () => {
    value.textContent = '$' + Number(range.value).toLocaleString();
    cashback.textContent = (Number(range.value) * 0.05).toLocaleString('en-AU', {
      style: 'currency',
      currency: 'AUD',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Class representing the Product Price User Interface.
   * Handles DOM updates for product prices, taxes, and discounts based on variant events.
   */
  class PriceUI {
    /**
     * Create a PriceUI instance and cache necessary DOM elements.
     */
    constructor() {
      this.priceSaleElement = document.querySelector('[data-product-price-sale]');
      this.priceGSTElement = document.querySelector('[data-product-price-gst]');
      this.priceCompareElement = document.querySelector('[data-product-price-compare]');
      this.discountAmountElement = document.querySelector('[data-product-discount-amount]');
      this.discountPercentageElement = document.querySelector('[data-product-discount-percentage]');
      this.priceBottomSectionElement = document.querySelector('.product-price__bottom');
    }

    /**
     * Updates the pricing elements in the DOM when a variant changes.
     * Bound as an arrow function to maintain the lexical scope of `this`.
     * 
     * @param {CustomEvent} event - The custom event containing variant details.
     * @param {Object} event.detail - The variant data object.
     * @param {number|string} event.detail.price - The current sale price in cents.
     * @param {number|string} [event.detail.compare_at_price] - The original comparison price in cents.
     */
    update = (event) => {
      const variant = event?.detail;
      if (!variant) return;

      const priceSale = Number(variant.price || 0);
      const priceCompare = Number(variant.compare_at_price || 0);
      
      const discountAmount = priceCompare - priceSale;
      const discountPercentage = this.priceOffPercentage(priceCompare, priceSale);

      if (this.priceSaleElement) {
        this.priceSaleElement.textContent = this.priceFormatter(priceSale);
      }
      
      if (this.priceGSTElement) {
        this.priceGSTElement.textContent = this.priceFormatter(Math.round(priceSale / 1.1));
      }

      if (this.priceCompareElement) {
        if (priceCompare > priceSale) {
          this.priceBottomSectionElement.style.display = '';
          this.priceCompareElement.textContent = this.priceFormatter(priceCompare);
        } else {
          this.priceBottomSectionElement.style.display = 'none';
          return;
        }
      }

      if (this.discountAmountElement) {
        if (discountAmount > 0) {
          this.discountAmountElement.textContent = this.priceFormatter(discountAmount);
          this.discountAmountElement.style.display = '';
        } else {
          this.discountAmountElement.style.display = 'none';
        }
      }

      if (this.discountPercentageElement) {
        if (discountPercentage > 0) {
          this.discountPercentageElement.textContent = `${discountPercentage}%`;
          this.discountPercentageElement.style.display = '';
        } else {
          this.discountPercentageElement.style.display = 'none';
        }
      }
    }

    /**
     * Calculates the percentage off from the original price.
     * 
     * @param {number} originalCents - The original comparison price in cents.
     * @param {number} saleCents - The active sale price in cents.
     * @returns {number} The calculated discount percentage rounded to the nearest integer.
     */
    priceOffPercentage(originalCents, saleCents) {
      if (!originalCents || originalCents <= saleCents) return 0;
      return Math.round(((originalCents - saleCents) / originalCents) * 100);
    }

    /**
     * Formats a price value from cents into a localized USD currency string.
     * 
     * @param {number} cents - The price value in cents.
     * @returns {string} The formatted USD currency string (e.g., "$10.00").
     */
    priceFormatter(cents) {
      const dollars = cents / 100;
      return dollars.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
    }
  }

  class StockUI {
    constructor() {
      this.wrapper = document.querySelector('[data-stock-ui]');
      this.inStockIndicator = this.wrapper?.querySelector('[data-stock-indicator="in"]');
      this.inStockText = this.wrapper?.querySelector('[data-stock-text="in"]');
      this.outStockIndicator = this.wrapper?.querySelector('[data-stock-indicator="out"]');
      this.outStockText = this.wrapper?.querySelector('[data-stock-text="out"]');

      this.update = this.update.bind(this);
      this.init();
    }

    init() {
      if (!this.wrapper) return;

      document.addEventListener('product-variant:changed', this.update);
    }

    toggleElement(element, isVisible) {
      if (!element) return;

      element.hidden = !isVisible;
      if (isVisible) {
        element.removeAttribute('aria-hidden');
      } else {
        element.setAttribute('aria-hidden', 'true');
      }
    }

    update(event) {
      const variant = event?.detail;
      if (!variant || !this.wrapper) return;

      const isAvailable = Boolean(variant.available);

      this.toggleElement(this.inStockIndicator, isAvailable);
      this.toggleElement(this.inStockText, isAvailable);
      this.toggleElement(this.outStockIndicator, !isAvailable);
      this.toggleElement(this.outStockText, !isAvailable);
    }
  }

  class ButtonUI {
    constructor() {
      this.button = document.querySelector('.product-form__add-button');
      this.buttonLabel = this.button?.querySelector('[data-button-label]');
      this.buttonIcon = this.button?.querySelector('[data-button-icon]');

      this.update = this.update.bind(this);
      this.init();
    }

    init() {
      if (!this.button) return;

      document.addEventListener('product-variant:changed', this.update);
    }

    setButtonState(isAvailable) {
      if (!this.button) return;

      this.button.disabled = !isAvailable;
      this.button.classList.toggle('button--disabled', !isAvailable);
      this.button.classList.toggle('button--primary', isAvailable);
      if (this.buttonIcon) {
        this.buttonIcon.hidden = !isAvailable;
        if (isAvailable) {
          this.buttonIcon.removeAttribute('aria-hidden');
        } else {
          this.buttonIcon.setAttribute('aria-hidden', 'true');
        }
      }

      if (isAvailable) {
        this.button.removeAttribute('aria-disabled');
        this.button.setAttribute('data-action', 'add-to-cart');
        this.button.setAttribute('type', 'submit');
        this.button.setAttribute('onclick', 'addToCart(event, this)');
      } else {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.removeAttribute('data-action');
        this.button.removeAttribute('onclick');
      }
    }

    setButtonLabel(isAvailable) {
      if (!this.buttonLabel) return;

      const availableLabel = this.button.dataset.buttonLabelAvailable;
      const unavailableLabel = this.button.dataset.buttonLabelUnavailable;
      this.buttonLabel.textContent = isAvailable ? (availableLabel || this.buttonLabel.textContent) : (unavailableLabel || this.buttonLabel.textContent);
    }

    update(event) {
      const variant = event?.detail;
      if (!variant || !this.button) return;

      const isAvailable = Boolean(variant.available);

      this.setButtonState(isAvailable);
      this.setButtonLabel(isAvailable);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const priceUI = new PriceUI();
    new StockUI();
    new ButtonUI();
    document.addEventListener('product-variant:changed', priceUI.update);
  });

  class VariantSelector {
    constructor(wrapper) {
      // Variant selector properties
      this.wrapper = wrapper;
      this.options = this.wrapper.querySelectorAll('img, .product-variant-selector__option-label');
      this.priceSale = document.querySelector('[data-product-price-sale]');
      this.priceGST = document.querySelector('[data-product-price-gst]');
      this.priceCompare = document.querySelector('[data-product-price-compare]');
      this.discountAmount = document.querySelector('[data-product-discount-amount]');
      this.discountPercentage = document.querySelector('[data-product-discount-percentage]');
      this.priceOff = document.querySelector('.product-price__off');
      this.product = null;
      this.variant = null;
      
      // Availability management properties
      this.optionGroups = [];
      this.variantMatrix = {};
      this.currentSelection = [];
      
      this.init();
    }

    async init() {
      // Initialize product data
      await this.setProduct()

      // Initialize variant selector
      this.setVariant();

      // Initialize availability management
      this.initAvailabilityManager();

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.onOptionClick(option));
      });
    }

    /**
     * Availability Management Methods
     */
    
    initAvailabilityManager() {
      this.buildOptionGroups();
      this.buildVariantMatrix();
      this.setInitialSelection();
      this.updateAllOptionsAvailability();
    }
    
    // Build option groups structure
    buildOptionGroups() {
      const groups = this.wrapper.querySelectorAll('.product-variant-selector__option-group');
      
      groups.forEach((group, groupIndex) => {
        const options = group.querySelectorAll('.product-variant-selector__option-image, .product-variant-selector__option-label');
        const optionValues = [];
        
        options.forEach(option => {
          optionValues.push({
            element: option,
            value: option.dataset.optionName,
            container: option.closest('.product-variant-selector__option')
          });
        });
        
        this.optionGroups.push({
          index: groupIndex,
          element: group,
          options: optionValues
        });
      });
    }

    isVariantAvailable(variant) {
      return Boolean(
        variant?.available ||
        variant?.inventory_management == null ||
        variant?.inventory_management === '' ||
        variant?.inventory_policy === 'continue'
      );
    }
    
    // Build variant lookup matrix
    buildVariantMatrix() {
      if (!this.product?.variants) return;
      
      this.product.variants.forEach(variant => {
        const key = variant.options.join('_').toLowerCase().replace(/\s+/g, '-');
        this.variantMatrix[key] = {
          available: variant.available
        };
      });
    }
    
    // Set initial selection based on selected options
    setInitialSelection() {
      this.optionGroups.forEach((group, index) => {
        const selectedOption = group.options.find(opt => 
          opt.element.classList.contains('selected')
        );
        
        this.currentSelection[index] = selectedOption ? selectedOption.value : null;
      });
    }
    
    // Update selection when option is clicked
    updateAvailabilitySelection(groupIndex, optionValue) {
      this.currentSelection[groupIndex] = optionValue;
      this.updateAllOptionsAvailability();
    }
    
    // Check if a combination of options has available variant
    checkVariantAvailability(optionArray) {
      const key = optionArray.join('_').toLowerCase().replace(/\s+/g, '-');
      const variantData = this.variantMatrix[key];
      return variantData && variantData.available;
    }
    
    // Find variant by option combination
    findVariantByOptions(optionArray) {
      const key = optionArray.join('_').toLowerCase().replace(/\s+/g, '-');
      const variantData = this.variantMatrix[key];
      return variantData ? variantData.variant : null;
    }
    
    // Main availability update logic
    updateAllOptionsAvailability() {
      this.optionGroups.forEach((group, groupIndex) => {
        group.options.forEach(option => {
          // Create a copy of current selection
          const optionSelection = [...this.currentSelection];
          optionSelection[groupIndex] = option.value;
          
          // Check availability
          const isAvailable = this.checkVariantAvailability(optionSelection);

          // Update UI
          option.container.classList.toggle('unavailable', !isAvailable);
        });
      });
    }
    
    /**
     * Variant Selector Methods
     */

    // Fetch product data by handle
    async getProduct(params) {
      const pathSegments = window.location.pathname.split('/');
      const handle = pathSegments[pathSegments.length - 1];
      if (!handle) return null;

      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.warn(`Error fetching data for handle "${handle}", please check if the product handle is correct:`, error);
        return {
          'message': 'Error fetching data for handle',
          'status': 'error',
          'handle': handle,
          'error': error
        };
      }
    }

    async setProduct() {
      this.product = await this.getProduct();
    }

    // Get currently selected variant based on selected options
    getVariant() {
      const selectedOptions = [];
      this.options.forEach((option) => {
        if (option.classList.contains('selected')) {
          selectedOptions.push(option.dataset.optionName);
        }
      });

      if (!this.product || !this.product.variants) return null;

      return this.product.variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      }) || null;
    }

    // Set the current variant
    setVariant() {
      this.variant = this.getVariant();
    }

    // Handle option click event
    onOptionClick(option) {
      // if (option.closest('.product-variant-selector__option').classList.contains('unavailable')) {
      //   return; // Do nothing if option is unavailable
      // }
      this.setOptionsSelected(option);
      
      // Update availability management selection
      const groupIndex = this.getOptionGroupIndex(option);
      const optionValue = option.dataset.optionName;
      this.updateAvailabilitySelection(groupIndex, optionValue);
      
      this.setVariant();
      if (this.variant) {
        this.setUrlParameter('variant', this.variant.id);
        this.setOptionLabel();
        this.dispatchVariantChangeEvent(this.variant);
      }
    }

    // Get index of the option group
    getOptionGroupIndex(option) {
      const optionGroup = option.closest('.product-variant-selector__option-group');
      const allGroups = this.wrapper.querySelectorAll('.product-variant-selector__option-group');
      return Array.from(allGroups).indexOf(optionGroup);
    }

    // Set selected class on the chosen option
    setOptionsSelected(option) {
      const imageGroup = option.closest('.product-variant-selector__option-group').querySelectorAll('img, .product-variant-selector__option-label');
      imageGroup.forEach((opt) => opt.classList.remove('selected'));
      option.classList.add('selected');
    }

    // Update URL parameter without reloading the page
    setUrlParameter(param, value) {
      const url = new URL(window.location);
      url.searchParams.set(param, value);
      window.history.replaceState({}, '', url);
    }

    // Update option labels to show selected values
    setOptionLabel() {
      this.wrapper.querySelectorAll('.product-variant-selector__label strong').forEach((label, index) => {
        const selectedOption = this.variant.options[index] || 'Select';
        label.textContent = selectedOption;
      });
    }

    // Dispatch custom event on variant change
    dispatchVariantChangeEvent(variant) {
      const event = new CustomEvent('product-variant:changed', { detail: variant });
      document.dispatchEvent(event);
    }
  }

  document.addEventListener('DOMContentLoaded', async function () {
    // Variant Selector With Images
    const variantOptionsWrapper = document.querySelector('.product-info__variant-selector');
    const variantSelector = new VariantSelector(variantOptionsWrapper);

    // Quantity controls are now handled by the quantity-selector block
  });

  document.addEventListener('product-variant:changed', (e) => {
    const sku = document.querySelector('[data-product-sku]');
    const variantIdInput = document.querySelector('#selected-variant-id');
    if (sku) {
      sku.textContent = e.detail.sku;
    }
    if (variantIdInput) {
      variantIdInput.value = e.detail.id;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
